export function updateFilterFields(state, payload) {
  state.filterFiles = payload;
}

export function updateRefresh(state, value) {
  state.refresh = value;
}

export function updateMenu(state, menu) {
  state.menu = menu;
}

export function setUserInfo(state, userinfo) {
  state.userinfo = userinfo;
}

export function updateMessageAmount(state, num) {
  state.messageAmount = num;
}

export function updateImNotifyMessage(state, message) {
  state.im_notify = message;
}

export function updateSocketMessage(state, message) {
  state.socket.message = message;
}

export function socketStatus(state, status) {
  state.socket.isConnected = status;
}

export function incMessageAmount(state) {
  state.messageAmount++;
}

export function decMessageAmount(state) {
  if (state.messageAmount > 0) {
    --state.messageAmount;
  }
}

export function setImUrl(state, url) {
  state.im_url = url;
}

export function upNewVisit(state, value) {
  state.isNewVisit = value;
}

export function upClickSave(state, value) {
  state.clickSave = value;
}

export function setLocal(state, value) {
  state.local = value;
}

export function setSyncInfo(state, value) {
  state.syncInfo = value;
}

export function setSuperDict(state, value) {
  state.superDict = value;
}

export function setMenuIndex(state, menuIndex) {
  state.menuIndex = menuIndex;
}

export function setBubbleCount(state, value) {
  state.bubbleCount = value;
}
